import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import * as Masonry from "masonry-layout";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import { ResourceService } from '../../../services/resource.service';
import { Poster } from '../../../models/poster';
import { Content } from '../../../models/content';


@Component({
  selector: 'app-poster',
  templateUrl: './poster.component.html',
  styleUrls: ['./poster.component.scss']
})
export class PosterComponent implements OnInit {

  @Input()
  private content: Content;

  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  @Input() private startingPage: number;
  @Output() private saveStartingPage = new EventEmitter<number>();

  @Output() posterClick = new EventEmitter<Poster>();
  @Output() userForbidden = new EventEmitter<Boolean>();

  posterJSON: JSON;
  loadingAnimations = ANIMATION_TYPES;
  mainLoading: Boolean;

  paginationEnabled = [false,false]; // [is prev-page btn enabled, is next-page btn enabled]

  masonryGrid: Masonry;

  inputSearch: string;

  constructor(private resourceService: ResourceService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.posterJSON = JSON.parse("{}");
    this.posterJSON['pgno'] = this.startingPage;
    this.posterJSON['pgcount'] = 12;
    this.posterJSON['loading'] = true;
    this.mainLoading = true;
    this.getPaginationInfo(true);
    this.inputSearch = null;
  }

  getPaginationInfo(flag: boolean): void{
    var self = this;
    this.resourceService.getPostersPaginationInfo(this.content, this.inputSearch)
    .then(
      count => {
        self.posterJSON['count'] = count;
        if(flag){
          this.getPostersForPage();
        }

      },
      err => {
        if(err.status){
          this.userForbidden.emit(true);
        }
        console.log(err)
      }
    )
  }

  getPostersForPage(): void{
    var self = this;
    this.resourceService.getPostersForPage(this.posterJSON['pgno'], this.posterJSON['pgcount'], this.content, this.inputSearch)
    .then(
      posters => {
        self.posterJSON['posters'] = posters;
        self.posterJSON['loading'] = false;
        self.mainLoading = false;
        for(var i in posters){
          self.getPreviewImage(posters[i]);
        }
      },
      err => {
        if(err.status){
          this.userForbidden.emit(true);
        }
        console.log(err)
      }
    );
    let testVals = [
      ((this.posterJSON['pgno']-1)*this.posterJSON['pgcount'])/this.posterJSON['count'],
      ((this.posterJSON['pgno'])*this.posterJSON['pgcount'])/this.posterJSON['count']
    ];
    this.paginationEnabled[0] = (testVals[0] > 0 && testVals[0] <= 1) ? true : false;
    this.paginationEnabled[1] = (testVals[1] > 0 && testVals[1] <= 1) ? true : false;

  }

  getPreviewImage(poster: Poster): any{
    var self = this;
    if(poster.thumbPreview){
      return poster.thumbPreview;
    } else{
      this.resourceService.getPosterThumbPreview(poster)
      .subscribe((res) => {
        poster.thumbPreview = self._sanitizer.bypassSecurityTrustResourceUrl(res);
      });
    }
    return true;
  }

  posterSelected(poster: Poster): void{
    this.posterClick.emit(poster);
    this.saveStartingPage.emit(this.posterJSON['pgno']);
  }

  changePage(n: number){
    let r = ((this.posterJSON['pgno']+n)*this.posterJSON['pgcount'])/this.posterJSON['count'];
    if( r > 0 && r <= 1 ){
      this.posterJSON['pgno'] += n==0 ? 1 : -1;
      this.getPostersForPage();
    }
  }

  onSearch(){
    this.posterJSON['pgno'] = 1;
    this.getPaginationInfo(true);
  }

  initMasonry(){

    this.masonryGrid = new Masonry('.masonry-grid',{
      itemSelector : '.masonry-grid-item',
      columnWidth : '.masonry-grid-sizer',
      percentPosition : true,
      horizontalOrder : true,
      gutter: '.masonry-gutter-sizer',
      transitionDuration: '0.35s'
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(){
    this.initMasonry();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gallery/poster/poster.component.ts